module.exports = __webpack_public_path__ + "12aaa6185dafc25a8e09886089e93b9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/Q@2x.png
// module id = 832
// module chunks = 0